{
	"title": "Verstuurde mails",
	"layout": {
		"greeting": "Hoi {{name}},",
		"greetingWithoutName": "Hoi,",
		"buttonFallback": "Werkt de knop niet? Kopieer dan deze link naar je browser:",
		"promise": "Vóór 17:00 besteld, vandaag verstuurd. Geen abonnement nodig.",
		"kvk": "KvK",
		"contact": "Contact",
		"shipping": "Verzenden en retourneren",
		"unsubscribe": "Geen nieuwsbrief meer ontvangen? Meld je af via deze link:",
		"unsubscribeLink": "Afmelden voor de nieuwsbrief"
	},
	"staffInvitation": {
		"subject": "{{inviterName}} nodigt je uit voor het beheer van {{appName}}",
		"preheader": "Koppel een passkey en je kunt meteen aan de slag.",
		"heading": "Je bent uitgenodigd",
		"intro": "{{inviterName}} heeft je uitgenodigd als medewerker in het beheer van {{appName}}.",
		"passkey": "Je kiest zelf hoe je inlogt: met een passkey (aanbevolen: je vingerafdruk, je gezicht of de pincode van je laptop of telefoon), of met je e-mailadres en een wachtwoord.",
		"action": "Uitnodiging accepteren",
		"expires": "De link werkt tot {{expiresAt}} en maar één keer.",
		"unexpected": "Verwachtte je deze uitnodiging niet? Dan kun je deze mail negeren."
	},
	"accountExists": {
		"subject": "Je hebt al een account bij {{appName}}",
		"preheader": "Log in met je e-mailadres en wachtwoord.",
		"heading": "Je hebt al een account",
		"intro": "Je probeerde een account aan te maken bij {{appName}}, maar met dit e-mailadres heb je er al een.",
		"login": "Log in met je e-mailadres en je wachtwoord. Wachtwoord vergeten? Dan vraag je op de inlogpagina een nieuw wachtwoord aan.",
		"action": "Inloggen",
		"unexpected": "Was jij dit niet? Dan kun je deze mail negeren. Er is niets aan je account veranderd."
	},
	"confirmEmail": {
		"subject": "Bevestig je e-mailadres voor {{appName}}",
		"preheader": "Nog één stap, dan is je account klaar.",
		"heading": "Bevestig je e-mailadres",
		"intro": "Je hebt een account aangemaakt bij {{appName}}. Bevestig je e-mailadres, dan kun je inloggen.",
		"action": "Bevestig mijn e-mailadres",
		"expires": "De link werkt tot {{expiresAt}} en maar één keer.",
		"unexpected": "Heb je geen account aangemaakt? Dan kun je deze mail negeren."
	},
	"resetPassword": {
		"subject": "Stel een nieuw wachtwoord in voor {{appName}}",
		"preheader": "Met de link in deze mail kies je een nieuw wachtwoord.",
		"heading": "Kies een nieuw wachtwoord",
		"intro": "Je hebt gevraagd om een nieuw wachtwoord voor je account bij {{appName}}.",
		"action": "Nieuw wachtwoord kiezen",
		"sessions": "Daarna ben je overal uitgelogd waar je nog ingelogd was.",
		"expires": "De link werkt tot {{expiresAt}} en maar één keer.",
		"unexpected": "Heb je dit niet gevraagd? Dan kun je deze mail negeren. Je wachtwoord blijft dan hetzelfde."
	},
	"businessApproved": {
		"subject": "Je zakelijke account bij {{appName}} is goedgekeurd",
		"preheader": "Je ziet nu je eigen prijzen en kunt op rekening bestellen.",
		"heading": "Je bent goedgekeurd",
		"intro": "Goed nieuws: we hebben de zakelijke aanvraag van {{companyName}} bij {{appName}} goedgekeurd.",
		"prices": "Log je in, dan zie je voortaan je eigen prijzen exclusief btw.",
		"onAccount_one": "Je kunt op rekening bestellen. Je betaalt de factuur binnen {{count}} dag na de factuurdatum.",
		"onAccount_other": "Je kunt op rekening bestellen. Je betaalt de factuur binnen {{count}} dagen na de factuurdatum.",
		"reverseCharge": "Omdat je bedrijf in België zit en je btw-nummer geldig is, verleggen we de btw: je betaalt 0% btw, en dat staat op de factuur vermeld.",
		"action": "Inloggen in de shop",
		"questions": "Heb je vragen over je account of je prijzen? Beantwoord dan gewoon deze mail."
	},
	"businessRejected": {
		"subject": "Je zakelijke aanvraag bij {{appName}}",
		"preheader": "We hebben je aanvraag niet goedgekeurd.",
		"heading": "Je aanvraag is niet goedgekeurd",
		"intro": "Bedankt voor de zakelijke aanvraag van {{companyName}} bij {{appName}}. We hebben hem helaas niet goedgekeurd.",
		"reason": "De reden: {{reason}}",
		"account": "Je account blijft gewoon werken: je kunt bestellen tegen de gewone prijzen.",
		"again": "Is er iets veranderd, of klopt er iets niet? Dan kun je een nieuwe aanvraag doen als je ingelogd bent, of deze mail beantwoorden."
	},
	"welcomeCode": {
		"subject": "Welkom bij de nieuwsbrief van {{appName}}: je welkomstcode",
		"preheader": "Je welkomstcode voor {{discount}} staat in deze mail.",
		"heading": "Welkom",
		"intro": "Leuk dat je je hebt aangemeld voor de nieuwsbrief van {{appName}}! Je hoort voortaan als eerste van nieuwe producten en acties.",
		"offer": "Als welkom krijg je {{discount}} op je eerste bestelling.",
		"codeIntro": "Je welkomstcode voor je eerste bestelling:",
		"codeUse": "Vul hem in je winkelmand of bij het afrekenen in.",
		"percentage": "{{percent}}% korting",
		"fixedAmount": "{{amount}} korting",
		"freeShipping": "gratis verzending",
		"action": "Naar de shop",
		"conditions": "De code werkt tot {{endsAt}} en maar één keer.",
		"conditionsWithMinimum": "De code werkt tot {{endsAt}} en maar één keer, bij een bestelling vanaf {{minimum}}."
	},
	"trackAndTrace": {
		"subject": "Je bestelling {{orderNumber}} is onderweg",
		"subjectCorrected": "Nieuwe trackingcode voor je bestelling {{orderNumber}}",
		"preheader": "Volg je pakket bij {{carrier}}.",
		"heading": "Je pakket is onderweg",
		"intro": "Goed nieuws: je bestelling {{orderNumber}} bij {{appName}} is verzonden.",
		"introCorrected": "In onze vorige mail over je bestelling {{orderNumber}} stond een verkeerde trackingcode. Sorry daarvoor! Dit is de goede.",
		"code": "Je pakket gaat met {{carrier}}. De trackingcode is {{code}}.",
		"action": "Volg je pakket",
		"reorder": "Bijna op? Bestel dezelfde pakken later opnieuw met één knop.",
		"reorderAction": "Bestel opnieuw",
		"questions": "Heb je een vraag over je bestelling? Beantwoord dan deze mail.",
		"headingCorrected": "Een nieuwe trackingcode"
	},
	"orderConfirmation": {
		"subject": "Je bestelling {{orderNumber}} bij {{appName}}",
		"heading": "Bedankt voor je bestelling",
		"preheaderPaid": "Bedankt voor je betaling van {{total}}. Je factuur staat klaar.",
		"preheaderTransfer": "Maak {{total}} over, dan sturen we je bestelling op.",
		"introPaid": "Bedankt voor je bestelling! We hebben je betaling van {{total}} voor bestelling {{orderNumber}} ontvangen. Dit heb je besteld:",
		"introTransfer": "Bedankt voor je bestelling {{orderNumber}}! Je betaalt per overboeking. Dit heb je besteld:",
		"invoice": "Je factuur {{invoiceNumber}} kun je downloaden via de knop hieronder.",
		"invoiceAction": "Download de factuur",
		"transfer": "Maak {{total}} over met betalingskenmerk {{reference}}. Doe dat vóór {{payBefore}}, anders vervalt je bestelling.",
		"transferFollows": "Maak {{total}} over vóór {{payBefore}}, anders vervalt je bestelling. Het rekeningnummer en het betalingskenmerk krijg je van onze betaalpartner Pay.nl.",
		"afterTransfer": "Zodra je betaling binnen is, krijg je je factuur en sturen we je bestelling op.",
		"shipping": "We pakken je bestelling zo snel mogelijk in. Je krijgt een mail met de track-en-tracecode zodra hij onderweg is.",
		"questions": "Vragen over je bestelling? Beantwoord deze mail gewoon.",
		"transferPage": "Het rekeningnummer en de rest van de betaalgegevens vind je op de betaalpagina van Pay.nl.",
		"transferAction": "Naar de betaalgegevens",
		"preheaderOnAccount": "Je bestelling komt eraan. Betaal de factuur van {{total}} uiterlijk {{dueOn}}.",
		"introOnAccount": "Bedankt voor je bestelling {{orderNumber}}! Je bestelt op rekening, dus we sturen je bestelling meteen op. Dit heb je besteld:"
	},
	"paymentReceived": {
		"subject": "Betaling ontvangen voor {{orderNumber}} bij {{appName}}",
		"preheader": "Bedankt voor je betaling van {{total}}. Je factuur staat klaar.",
		"heading": "Je betaling is binnen",
		"intro": "We hebben je betaling van {{total}} voor bestelling {{orderNumber}} ontvangen. Dank je wel!",
		"invoice": "Je factuur {{invoiceNumber}} kun je downloaden via de knop hieronder.",
		"action": "Download de factuur"
	},
	"onAccount": {
		"pay": "Betaal factuur {{invoiceNumber}} van {{total}} uiterlijk {{dueOn}} per overboeking, met betalingskenmerk {{reference}}. Vermeld dat kenmerk, dan verwerken we je betaling automatisch.",
		"payToAccount": "Betaal factuur {{invoiceNumber}} van {{total}} uiterlijk {{dueOn}} per overboeking op {{iban}} t.n.v. {{accountHolder}}, met betalingskenmerk {{reference}}.",
		"payPage": "Het rekeningnummer en de rest van de betaalgegevens vind je op de betaalpagina van Pay.nl: {{payUrl}}"
	},
	"onAccountNewAddress": {
		"subject": "Je bestelling {{orderNumber}} op rekening gaat naar een nieuw verzendadres",
		"preheader": "Was jij dit? Dan hoef je niets te doen.",
		"heading": "Een bestelling naar een nieuw adres",
		"intro": "Er is bij {{appName}} met je account een bestelling op rekening geplaatst ({{orderNumber}}), met een verzendadres dat niet in je adresboek staat:",
		"ifYou": "Heb jij deze bestelling geplaatst? Dan hoef je niets te doen. Herken je de bestelling of het adres niet? Neem dan meteen contact met ons op, dan houden we de bestelling tegen.",
		"action": "Neem contact op",
		"password": "Was jij het niet? Kies dan ook een nieuw wachtwoord via \"Wachtwoord vergeten\" op de inlogpagina."
	},
	"invoiceReminder": {
		"subject": "Herinnering: factuur {{invoiceNumber}} van {{appName}}",
		"preheader": "Factuur {{invoiceNumber}} van {{total}} betaal je uiterlijk {{dueOn}}.",
		"heading": "Je factuur staat nog open",
		"introOverdue": "Factuur {{invoiceNumber}} voor bestelling {{orderNumber}}, van {{total}}, had uiterlijk {{dueOn}} betaald moeten zijn. We hebben je betaling nog niet ontvangen. Misschien is het erbij ingeschoten?",
		"introDue": "Even een herinnering: factuur {{invoiceNumber}} voor bestelling {{orderNumber}}, van {{total}}, betaal je uiterlijk {{dueOn}}.",
		"action": "Download de factuur",
		"alreadyPaid": "Heb je net betaald? Dan hebben deze mail en je betaling elkaar gekruist en hoef je niets meer te doen.",
		"questions": "Vragen over deze factuur? Beantwoord deze mail gewoon.",
		"headingDue": "Een herinnering voor je factuur"
	},
	"creditInvoice": {
		"subject": "Terugbetaling voor {{orderNumber}} bij {{appName}}",
		"preheader": "We hebben {{total}} aan je terugbetaald.",
		"heading": "We hebben je geld teruggestort",
		"intro": "We hebben {{total}} van je bestelling {{orderNumber}} aan je terugbetaald.",
		"timing": "Het bedrag staat binnen een paar werkdagen weer op je rekening, op dezelfde manier als je betaald hebt.",
		"invoice": "Je creditfactuur {{creditInvoiceNumber}} kun je downloaden via de knop hieronder.",
		"action": "Download de creditfactuur",
		"cancelledSubject": "Bestelling {{orderNumber}} geannuleerd bij {{appName}}",
		"cancelledPreheader": "Je bestelling {{orderNumber}} is geannuleerd. Je hoeft niets te betalen.",
		"cancelledIntro": "Je bestelling {{orderNumber}} is geannuleerd. Factuur {{invoiceNumber}} van {{total}} vervalt daarmee: je hoeft niets te betalen.",
		"cancelledHeading": "Je bestelling is geannuleerd"
	},
	"invoicePaid": {
		"subject": "Betaling ontvangen voor {{invoiceNumber}} bij {{appName}}",
		"preheader": "Bedankt, we hebben {{total}} voor factuur {{invoiceNumber}} ontvangen.",
		"heading": "Je betaling is binnen",
		"intro": "We hebben je betaling van {{total}} voor factuur {{invoiceNumber}} (bestelling {{orderNumber}}) ontvangen. Dank je wel!"
	},
	"contactMessage": {
		"subject": "Contactformulier: {{subject}}",
		"preheader": "Een bericht van {{name}} via het contactformulier.",
		"heading": "Een bericht via het contactformulier",
		"intro": "Er kwam een bericht binnen via het contactformulier op de site.",
		"introSignedIn": "Er kwam een bericht binnen via het contactformulier op de site, van een ingelogde klant.",
		"from": "Van: {{name}} ({{email}})",
		"order": "Ordernummer: {{orderNumber}}",
		"about": "Onderwerp: {{subject}}",
		"reply": "Beantwoord deze mail en je antwoord gaat naar {{name}} ({{email}})."
	},
	"contactReceipt": {
		"subject": "We hebben je bericht ontvangen",
		"preheader": "Bedankt voor je bericht. We reageren zo snel mogelijk.",
		"heading": "We hebben je bericht",
		"intro": "Bedankt voor je bericht aan {{appName}}. Het is goed aangekomen.",
		"answer": "We lezen het zo snel mogelijk en mailen je ons antwoord.",
		"add": "Wil je nog iets toevoegen? Beantwoord deze mail gewoon.",
		"unexpected": "Heb je ons geen bericht gestuurd? Dan kun je deze mail negeren."
	},
	"staffLoginCode": {
		"subject": "Je inlogcode voor het beheer van {{appName}}",
		"preheader": "Vul deze code in om in te loggen.",
		"heading": "Je inlogcode",
		"intro": "Je logt in op het beheer van {{appName}} vanaf een browser die we nog niet kennen. Vul deze code in:",
		"expires": "De code werkt tot {{expiresAt}} en maar één keer. Daarna onthoudt die browser je 30 dagen.",
		"unexpected": "Probeerde je niet in te loggen? Dan kent iemand anders je wachtwoord. Stel dan meteen een nieuw wachtwoord in via \"Wachtwoord vergeten\" op de inlogpagina."
	},
	"staffNewDevice": {
		"subject": "Er is ingelogd op een nieuw apparaat",
		"preheader": "Was jij dit? Dan hoef je niets te doen.",
		"heading": "Ingelogd op een nieuw apparaat",
		"intro": "Op {{signedInAt}} is er met je wachtwoord en een code ingelogd op het beheer van {{appName}}, vanaf een browser die nog niet eerder gebruikt was.",
		"unexpected": "Was jij dit niet? Stel dan meteen een nieuw wachtwoord in via \"Wachtwoord vergeten\". Daarmee log je ook overal uit.",
		"action": "Nieuw wachtwoord kiezen"
	},
	"staffAccountLocked": {
		"subject": "Je account voor het beheer van {{appName}} staat even op slot",
		"preheader": "Na 10 verkeerde wachtwoorden kun je even niet inloggen.",
		"heading": "Je account staat even op slot",
		"intro": "Er is 10 keer een verkeerd wachtwoord ingevuld voor je account in het beheer van {{appName}}. Daarom staat inloggen met je wachtwoord even op slot.",
		"until": "Vanaf {{lockedUntil}} kun je weer inloggen.",
		"action": "Nieuw wachtwoord kiezen",
		"unexpected": "Was jij dit niet? Dan probeert iemand je wachtwoord te raden. Kies dan een nieuw, sterk wachtwoord via \"Wachtwoord vergeten\"."
	},
	"staffPasswordReset": {
		"subject": "Stel een nieuw wachtwoord in voor het beheer van {{appName}}",
		"preheader": "Met de link in deze mail kies je een nieuw wachtwoord.",
		"heading": "Kies een nieuw wachtwoord",
		"intro": "Je hebt gevraagd om een nieuw wachtwoord voor het beheer van {{appName}}.",
		"action": "Nieuw wachtwoord kiezen",
		"sessions": "Daarna ben je overal uitgelogd, en vraagt elke browser weer om een code per mail.",
		"expires": "De link werkt tot {{expiresAt}} en maar één keer.",
		"unexpected": "Heb je dit niet gevraagd? Dan kun je deze mail negeren. Er verandert dan niets."
	},
	"reviewInvitation": {
		"subject": "Hoe bevallen de doekjes?",
		"preheader": "Geef je sterren: één tik per product.",
		"heading": "Hoe bevallen ze?",
		"intro": "Op {{date}} hebben we je bestelling {{orderNumber}} verstuurd. Geef per product sterren; daarna kun je er een korte tekst bij schrijven. Je review krijgt het label \"Geverifieerde koper\".",
		"prompt": "Tik op een ster:",
		"closing": "Eén tik is genoeg. We lezen elke review voordat hij online komt.",
		"optOut": "Geen reviewverzoeken meer ontvangen? Meld je af via deze link:",
		"optOutLink": "Geen reviewverzoeken meer",
		"stars": "{{count}} van 5",
		"withPack": "{{name}} · pak van {{count}}"
	}
}
